import { DatePicker } from './../components/date_picker_controller';
import { IDay, IWeekDay } from './../date_picker_interface';
import { DatePickerBaseServant } from './date_picker_base_servant';

export class DatePickerDefaultServant extends DatePickerBaseServant {
  private servant: DatePickerBaseServant;
  private _onSelect: Function;

  constructor(ngDatePickerBaseServant: DatePickerBaseServant) {
    super();
  }

  public constructDates(dates: Array<string>): Array<IDay> {
    return [] as Array<IDay>;
  }

  public initialize(datePicker: DatePicker): void {
    let updatedSelectTime: IDay = {} as IDay;
    this._initializeDefaultAvailableTimes(datePicker);

    const { displayDate, month, year } = datePicker.selectedDay;
    const { time } = datePicker.selectedTime;
    updatedSelectTime = _.find(datePicker.timingArray, { time });

    if (!_.isEmpty(datePicker.selectedDay)) {
      let limitLoop = 0;
      while (_.isEmpty(_.find(datePicker.week, { displayDate, month, year })) || limitLoop === 10) {
        this.nextWeek(datePicker, true);
        limitLoop++;
      }
    }

    if (!_.isEmpty(updatedSelectTime)) {
      updatedSelectTime.selected = true;
      datePicker.selectedTime = updatedSelectTime;
    }

    this._onSelect = datePicker.onSelect;
  }

  public selectionChange(selectedDay: IWeekDay, selectedTime: IDay): any {
    this._onSelect({ selectedDay, selectedTime });
  }

  public nextWeek(datePicker: DatePicker, preserveSelections?: boolean): void {
    datePicker.resetOnSelectionChange(preserveSelections);
    datePicker.week = this.getWeek(datePicker.current_week_lastdate, datePicker);
    datePicker.isPreviousWeekEnabled();
  }

  public previousWeek(datePicker: DatePicker): void {
    datePicker.resetOnSelectionChange();
    let start_of_week = datePicker.previous_week_firstdate;
    datePicker.week = this.getWeek(start_of_week, datePicker);
    datePicker.isPreviousWeekEnabled();
  }

  public hasSelectedTime(time: IDay, selectedTime: IDay): boolean {
    return false;
  }

  public getAvailableTimes(timingArray: Array<IDay>, selectedDay: IWeekDay): Array<IDay> {
    if (!_.isEmpty(selectedDay)) {
      _.forEach(timingArray, (time) => {
        time.date = selectedDay.date;
        time.day = selectedDay.day;
        time.day_week = selectedDay.day_week;
      });
    }
    return timingArray;
  }

  public getWeekStartDate(timingArray: Array<IDay>): moment.Moment {
    return moment().startOf('week');
  }

  private _initializeDefaultAvailableTimes(datePicker: DatePicker): any {
    const STARTTIME = '08:00';
    const INTERVAL = 15;
    const PERIOD = 'm';

    let periodsInADay = moment.duration(1, 'day').as(PERIOD) / INTERVAL;
    let startTime = moment(STARTTIME, 'hh:mm');

    datePicker.timingArray = [];

    _.times(periodsInADay, (key) => {
      startTime.add(key === 0 ? 0 : INTERVAL, PERIOD);
      datePicker.timingArray.push(this.buildTimeObject(startTime, true));
    });
  }
}

angular.module('ui-ng-mobile-date-picker').service('ngDatePickerDefaultServant', DatePickerDefaultServant);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-mobile-date-picker/src/servants/date_picker_default_servant.ts